"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressFields = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable no-prototype-builtins */
const react_1 = __importDefault(require("react"));
const antd_1 = require("antd");
const debounce_1 = __importDefault(require("lodash/debounce"));
const react_intl_1 = require("react-intl");
const i18nIsoCountries = __importStar(require("i18n-iso-countries"));
const address_1 = require("@src/api/address");
const sk_json_1 = __importDefault(require("i18n-iso-countries/langs/sk.json"));
const en_json_1 = __importDefault(require("i18n-iso-countries/langs/en.json"));
const icons_1 = require("@ant-design/icons");
const Api = __importStar(require("@src/api"));
const app_context_1 = require("@src/context/app-context");
const elements_1 = require("@src/components/elements");
const normalize_string_1 = require("@src/helpers/normalize-string");
const types_1 = require("@src/types");
const styled_components_1 = __importDefault(require("styled-components"));
i18nIsoCountries.registerLocale(sk_json_1.default);
i18nIsoCountries.registerLocale(en_json_1.default);
function isInternalNamePath(name) {
    return Array.isArray(name);
}
function SuggestionAddressOptionLabel({ type, label }) {
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex-row align-center", children: [type === address_1.AddressSuggestionsTypes.Addresses && (0, jsx_runtime_1.jsx)(IconStyled, { type: "pin-location" }), type === address_1.AddressSuggestionsTypes.Cities && (0, jsx_runtime_1.jsx)(IconStyled, { type: "building-outlined" }), label] }));
}
/**
 * Creates copy of current form data with only provided address values changed
 */
function getNewFieldsValue(currentFields, currentNamePath, newAddressValue) {
    const isAddress = currentFields.hasOwnProperty('google_place_id') &&
        currentFields.hasOwnProperty('formatted_address') &&
        currentFields.hasOwnProperty('country') &&
        currentFields.hasOwnProperty('utcOffset');
    if (isAddress) {
        return { ...currentFields, ...newAddressValue };
    }
    const nextFieldsKey = isInternalNamePath(currentNamePath) ? currentNamePath[0] : currentNamePath;
    const nextFields = currentFields[nextFieldsKey];
    const nextNamePath = isInternalNamePath(currentNamePath) ? currentNamePath.slice(1) : [];
    return {
        ...currentFields,
        [nextFieldsKey]: getNewFieldsValue(nextFields, nextNamePath, newAddressValue),
    };
}
const AddressFields = ({ baseName, form, formattedAddressLabel, countryLabel, initValues, }) => {
    const [addressSuggestions, setAddressSuggestions] = react_1.default.useState([]);
    const appContext = (0, app_context_1.useAppContextValue)();
    const intl = (0, react_intl_1.useIntl)();
    function getFieldName(lastNameSegment) {
        return isInternalNamePath(baseName) ? [...baseName, lastNameSegment] : [baseName, lastNameSegment];
    }
    function setAddressFields(newAddressValue) {
        const newFieldsValue = getNewFieldsValue(form.getFieldsValue(), baseName, newAddressValue);
        form.setFieldsValue(newFieldsValue);
    }
    function showErrorNotification() {
        antd_1.notification.error({
            message: intl.formatMessage({ id: 'general.error' }),
            description: intl.formatMessage({ id: 'general.something_went_wrong' }),
        });
    }
    async function fetchAndSetAddressSuggestions(newValue) {
        if (newValue.length < 2) {
            return;
        }
        try {
            const currentCountryCode = form.getFieldValue(getFieldName('country'));
            const addressSuggestionResponse = await Api.Address.getAddressSuggestions(newValue, currentCountryCode);
            setAddressSuggestions(Object.entries(addressSuggestionResponse).map(([key, options]) => ({
                label: intl.formatMessage({ id: key }),
                options: options.map(a => ({
                    value: a.description,
                    id: a.place_id,
                    label: ((0, jsx_runtime_1.jsx)(SuggestionAddressOptionLabel, { type: key, label: a.description })),
                })),
            })));
        }
        catch (err) {
            console.error(err);
            showErrorNotification();
        }
    }
    const debouncedFetchAndSetAddressSuggestions = (0, debounce_1.default)(fetchAndSetAddressSuggestions, 300);
    const handleAddressSearch = (newFormattedAddress) => {
        debouncedFetchAndSetAddressSuggestions(newFormattedAddress);
        setAddressFields({ google_place_id: null, formatted_address: newFormattedAddress });
    };
    const onAutoCompleteSelect = async (selectedAddress, option) => {
        const details = await Api.Address.getAddressDetail(option.id);
        setAddressFields({
            google_place_id: option.id,
            formatted_address: selectedAddress,
            utcOffset: details.utcOffset,
        });
        setAddressSuggestions([]);
    };
    const handleCountrySelect = () => {
        setAddressFields({ google_place_id: null, formatted_address: null });
        setAddressSuggestions([]);
    };
    const countries = react_1.default.useMemo(() => Object.entries(i18nIsoCountries.getNames(appContext.language)), [appContext.language]);
    react_1.default.useEffect(() => {
        const countryByLanguage = {
            [types_1.SupportedLanguage.en]: 'GB',
            [types_1.SupportedLanguage.sk]: 'SK',
        }[appContext.language];
        const currentAddress = form.getFieldValue(baseName);
        if (!(currentAddress === null || currentAddress === void 0 ? void 0 : currentAddress.country)) {
            setAddressFields({ country: countryByLanguage });
        }
        if (initValues) {
            form.setFieldsValue(initValues);
        }
    }, []);
    function checkAddressGooglePlaceId() {
        const googlePlaceId = form.getFieldValue(getFieldName('google_place_id'));
        if (!googlePlaceId) {
            return Promise.reject(new Error());
        }
        return Promise.resolve();
    }
    return ((0, jsx_runtime_1.jsxs)(antd_1.Row, { gutter: [16, 8], children: [(0, jsx_runtime_1.jsx)(antd_1.Col, { xs: 24, sm: 6, children: (0, jsx_runtime_1.jsx)(antd_1.Form.Item, { label: countryLabel, name: getFieldName('country'), rules: [{ required: true, message: intl.formatMessage({ id: 'global.address.country.fill' }) }], labelCol: { span: 24 }, wrapperCol: { span: 24 }, children: (0, jsx_runtime_1.jsx)(elements_1.Select, { showSearch: true, optionFilterProp: "children", filterOption: (input, option) => (0, normalize_string_1.normalizeStr)(option.children).indexOf((0, normalize_string_1.normalizeStr)(input)) >= 0, onChange: handleCountrySelect, children: countries.map(([code, name]) => ((0, jsx_runtime_1.jsx)(elements_1.Select.Option, { value: code, children: name }, code))) }) }) }), (0, jsx_runtime_1.jsx)(antd_1.Col, { xs: 24, sm: 18, children: (0, jsx_runtime_1.jsx)(antd_1.Form.Item, { label: formattedAddressLabel, name: getFieldName('formatted_address'), required: true, dependencies: [['address', 'google_place_id']], rules: [
                        {
                            validator: checkAddressGooglePlaceId,
                            message: intl.formatMessage({ id: 'global.address.formatted_address.fill' }),
                            validateTrigger: 'onBlur',
                        },
                    ], labelCol: { span: 24 }, wrapperCol: { span: 24 }, children: (0, jsx_runtime_1.jsx)(antd_1.AutoComplete, { onSearch: handleAddressSearch, options: addressSuggestions, onSelect: onAutoCompleteSelect, children: (0, jsx_runtime_1.jsx)(elements_1.Input, { prefix: (0, jsx_runtime_1.jsx)(icons_1.SearchOutlined, {}), placeholder: intl.formatMessage({ id: 'global.address.formatted_address.placeholder' }) }) }) }) }), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, { name: getFieldName('google_place_id'), hidden: true, children: (0, jsx_runtime_1.jsx)(elements_1.Input, {}) }), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, { name: getFieldName('utcOffset'), hidden: true, children: (0, jsx_runtime_1.jsx)(elements_1.Input, {}) })] }));
};
exports.AddressFields = AddressFields;
const IconStyled = (0, styled_components_1.default)(elements_1.Icon) `
	svg {
		width: 16px;
		margin-right: 4px;
	}
`;
